import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { BgColorsOutlined } from '@ant-design/icons';

import Drawer from "./Drawer";
import "./index.less";

const Addon = function (props) {

    const [visible, setVisible] = useState(false);

    // useEffect(() => {
    //     if (props.clickStamp) {
    //         setVisible(true)
    //     }
    // }, [props.clickStamp])

    return <>
        {/* <Menu.Item {...props} key={"主题设置"} icon={<BgColorsOutlined />} onClick={e => setVisible(true)}>
            主题设置
        </Menu.Item> */}
        <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }} onClick={e=>{
            setVisible(true)
        }}></div>
        <div>主题设置</div>
        <Drawer visible={visible} onClose={e => {
            e.stopPropagation();
            setVisible(false)
        }}>
        </Drawer>
    </>
}

Addon.menuItem = (props) => {
    const key = "主题设置";
    return {
        key,
        label: <Addon />,
        icon: <BgColorsOutlined />,
        style: {
            position: 'relative'
        }
    }
}

export default Addon;